import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Translate from '../../i18n/Translate'
import DestinationSearch from '../../components/DestinationSearch'

const TopSearch = () => {
    const topSearchRef = useRef(null)
    const location = useLocation()

    //Si la url tiene un search entonces hacemos foco en el buscador de destinos
    useEffect(() => {
        if (location.search) {
            topSearchRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [location])

    return (
        <div className="top-search" ref={topSearchRef}>
            <h2 className="top-search__title">
                <Translate langkey="itinerary.top_search.title" />
            </h2>
            <div className="top-search__search-wrapper">
                <DestinationSearch />
            </div>
        </div>
    )
}

export default TopSearch
